import { useMilestone } from "@faire/marketplace-lib/stores/useMilestone";
import { SHOPIFY_LEAD_ELIGIBLE_FOR_INCENTIVES } from "@faire/web-api--source/indigofair/data/IUserMilestone/RetailerMilestone/SHOPIFY_LEAD_ELIGIBLE_FOR_INCENTIVES";
import { SHOPIFY_LEAD_UPGRADED_PLAN } from "@faire/web-api--source/indigofair/data/IUserMilestone/RetailerMilestone/SHOPIFY_LEAD_UPGRADED_PLAN";

export const useShopifyOfferEligibility = () => {
  const { hasOccurred: shopifyLeadEligibleForIncentives } = useMilestone(
    SHOPIFY_LEAD_ELIGIBLE_FOR_INCENTIVES
  );
  const { hasOccurred: shopifyLeadUpgradedPlan } = useMilestone(
    SHOPIFY_LEAD_UPGRADED_PLAN
  );

  return {
    showEligibleShopifyOfferIncentives:
      shopifyLeadEligibleForIncentives && !shopifyLeadUpgradedPlan,
    hasClaimedShopifyOffer: shopifyLeadUpgradedPlan,
  };
};
